import api from "./api";
import { getStoredUser, getStoredClientId } from "../utils/tokenUtils";

/**
 * Field service for managing custom fields
 */
export const fieldService = {
  /**
   * Get all fields
   */
  getFields: async (filters = {}) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      ...filters,
      client_id: filters.client_id || storedClientId || user?.client_id,
    };
    const response = await api.post("/api/fields/list", payload);
    return response.data;
  },

  /**
   * Get field by ID
   */
  getFieldById: async (fieldId) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const response = await api.post("/api/fields/get", {
      field_id: fieldId,
      client_id: storedClientId || user?.client_id,
    });
    return response.data;
  },

  /**
   * Create field
   */
  createField: async (fieldData) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      ...fieldData,
      client_id: fieldData.client_id || storedClientId || user?.client_id,
    };
    const response = await api.post("/api/fields/create", payload);
    return response.data;
  },

  /**
   * Update field
   */
  updateField: async (fieldId, updates) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const response = await api.post("/api/fields/update", {
      field_id: fieldId,
      ...updates,
      client_id: updates.client_id || storedClientId || user?.client_id,
    });
    return response.data;
  },

  /**
   * Delete field
   */
  deleteField: async (fieldId) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const response = await api.post("/api/fields/delete", {
      field_id: fieldId,
      client_id: storedClientId || user?.client_id,
    });
    return response.data;
  },
};

export default fieldService;
